// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"24d822cb","253":"548d5f39","336":"cbbca509","393":"6a865d24","412":"c23b1ee4","435":"991640bd","870":"562e1fd0","949":"d3cf5d08"}[chunkId] + ".chunk.js";
};